<div
    class="activity-task-toggle"
    (focusin)="activityTaskTooltip.show()"
    (focusout)="activityTaskTooltip.hide()">
    <mat-slide-toggle
        color="primary"
        [hideIcon]="true"
        [checked]="(selectedService.selectedSubject | async)?.activity?.show_tasks === true"
        [disabled]="isTogglingActivityTasks"
        (change)="onActivityTaskToggleChange($event)">
        <span>
            {{'activity-task-toggle-label' | translate}}
            <span class="cdk-visually-hidden">{{'activity-task-toggle-tooltip' | translate}}</span>
        </span>
    </mat-slide-toggle>
    <mat-icon
        class="ficon-app-help-circle-outline"
        aria-hidden="true"
        #activityTaskTooltip="matTooltip"
        [matTooltip]="'activity-task-toggle-tooltip' | translate"
        matTooltipClass="multi-line-tooltip"
        matTooltipPosition="below">
    </mat-icon>
</div>
